import { cx } from '@twind/core';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

import { useContactFormLinkClick } from '../hooks/useContactFormLinkClick';
import { FormItemCheckbox } from '../types';
import useContactFormTracking from '../hooks/useContactFormTracking';

type Props = { item: FormItemCheckbox; isSubmitted: boolean; contactFormSlug?: string };

export function ContactFormCheckbox({ item, isSubmitted, contactFormSlug }: Props) {
  const hasErrors = !!item.errors?.length;
  const showError = isSubmitted && hasErrors;
  const errorId = `contact-form-checkbox-error-${item.ref_id}`;
  const { captureContactFormCheckbox } = useContactFormTracking();
  const { handleLinkClick } = useContactFormLinkClick(contactFormSlug);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    captureContactFormCheckbox({
      fieldName: item.event_name,
      checked: e.target.checked,
      required: item.required,
      text: item.label,
      contactFormSlug,
    });
  };

  return (
    <div className="ostro-contact-form-checkbox flex flex-col gap-2">
      <label className="flex gap-3 items-start cursor-pointer">
        <input
          type="checkbox"
          name={item.ref_id}
          defaultChecked={item.value === 'true'}
          required={item.required}
          className={cx(
            'accent-[#000000] shrink-0 h-4 w-4 mt-1',
            showError ? 'outline-[#FF3323]' : 'outline-typography-divider'
          )}
          onChange={handleChange}
          aria-invalid={showError}
          aria-describedby={showError ? errorId : undefined}
        />
        <OstroDynamicContent
          dangerouslySetInnerHTML={{ __html: item.label }}
          className="text-sm [&_p]:mb-0"
          onClick={handleLinkClick}
        />
      </label>
      {showError && (
        <div
          className="text-xs text-[#FF3323]"
          id={errorId}
        >
          {item.errors?.join(', ')}
        </div>
      )}
    </div>
  );
}
